__turbopack_context__.v({
  "mb": "styles-module-scss-module__UHmK1a__mb",
});
